export const gitCommit = '36bafc5b'
